import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Check } from "src/app/shared/models/check";
import { Order } from "src/app/shared/models/order";

declare let gtag: Function;

@Injectable({
	providedIn: "root",
})
export class GoogleAnalyticsService {
	constructor(private router: Router) {}

	public init(siteCode: string, app: string) {
		gtag("config", siteCode, {});
		this.event("app", "appUse", "app used", app);
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				gtag("set", "page_path", event.urlAfterRedirects);
				gtag("event", "page_view");
			}
		});
	}

	public pageView() {
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				gtag("config", "G-XZ9NMEKSX3", {
					page_path: event.urlAfterRedirects,
				});
			}
		});
	}

	public setVenue(venueKey: number, venueName: string) {
		this.event("venue", "venue", "venue used", `${venueKey} - ${venueName}`);
	}
	public event(eventName: string, category: string, label: string, value: string) {
		gtag("event", eventName, {
			event_category: category,
			event_label: label,
			event_value: value,
		});
	}

	public eventEmitter(eventName: string, eventCategory: string, eventAction: string, eventLabel: string = null, eventValue: number = null) {
		gtag("event", eventName, {
			eventCategory: eventCategory,
			eventLabel: eventLabel,
			eventAction: eventAction,
			eventValue: eventValue,
		});
	}

	public purchaseEmitter(gtagOrder) {
		gtag("event", "purchase", gtagOrder);
	}

	orderToGtagPurchase(order: Order | Check) {
		const gTagOrderEvent = {
			transaction_id: order.checkKey,
			affiliation: order.venueKey,
			value: order.total,
			currency: "USD",
			tax: order.taxtotal,
			shipping: 0,
			items: [],
		};

		order.seats.forEach((seat) => {
			seat.items.forEach((item) => {
				gTagOrderEvent.items.push({
					id: item.menuItemKey.toString(),
					name: item.name,
					brand: order.venueKey,
					category: "Food",
					quantity: item.quantity,
					price: item.price,
				});
			});
		});

		return gTagOrderEvent;
	}
}
